import React, { useEffect, useState } from "react";
import { getInputErrorMessage, hasErrorInput, SelectUtils } from "../../utils";
import Select2 from "../../components/Select2";
import {
  FormGroup,
  FormGroupVerticalInput,
  RadioInput,
  Label,
  TextInput,
} from "../../components";
import { range } from "../../utils/array-utils";

const MachineFormAdd = ({
  settings,
  groupsList,
  groupsChildren,
  addData,
  setAddData,
  errors,
}) => {
  const [addMachineOptions, setAddMachineOptions] = useState({});
  useEffect(() => {
    const groupOptions = SelectUtils.getChildGroupOptions(
      groupsChildren,
      addData,
      groupsList
    );
    setAddMachineOptions(groupOptions);
  }, [addData, groupsChildren, groupsList]);

  const handleSetAddData = (level, data) => {
    setAddData((prevData) => {
      const newFilterData = { ...prevData, [level]: data };
      for (let i = level + 1; i < 6; i++) {
        newFilterData[i] = null;
      }
      return newFilterData;
    });
  };

  return (
    <div className="">
      {range(1, 5).map(
        (level) =>
          settings &&
          settings[`group_${level}`]?.active && (
            <FormGroup direction="horizontal">
              <Label
                text={settings[`group_${level}`]?.name}
                className="whitespace-nowrap w-[288px]"
                required
              />
              <FormGroupVerticalInput
                error={getInputErrorMessage(errors, `group_${level}_id`)}
              >
                <Select2
                  options={addMachineOptions[level]}
                  value={SelectUtils.getSelectedGroupValueForTable(
                    addMachineOptions[level],
                    addData[level]
                  )}
                  hasError={hasErrorInput(errors, `group_${level}_id`)}
                  classNamePrefix="react-select"
                  classSelect="machine-update__form--select"
                  className="w-[320px]"
                  onChange={(e) => handleSetAddData(level, e.value)}
                  maxLength="30"
                  placeholder=""
                />
              </FormGroupVerticalInput>
            </FormGroup>
          )
      )}
      <FormGroup direction="horizontal">
        <Label
          text={settings.machine.name}
          required
          className="whitespace-nowrap w-[288px]"
          htmlFor="name"
        />
        <FormGroupVerticalInput error={getInputErrorMessage(errors, "name")}>
          <TextInput
            name="name"
            id="name"
            hasError={hasErrorInput(errors, "name")}
            onChange={(e) => setAddData({ ...addData, name: e.target.value })}
            value={addData.name || ""}
            maxLength="200"
            className="w-[320px]"
          />
        </FormGroupVerticalInput>
      </FormGroup>
      <FormGroup direction="horizontal" className="!mb-0">
        <Label text="状態" required className="w-[288px]" htmlFor="status" />
        <FormGroupVerticalInput error={getInputErrorMessage(errors, "status")}>
          <div className="flex">
            <RadioInput
              id="valid"
              name="status"
              value={1}
              label="有効"
              onChange={(e) =>
                setAddData({ ...addData, status: e.target.value })
              }
              checked={addData.status === "1" ? true : false}
            />
            <RadioInput
              id="invalid"
              name="status"
              value={0}
              label="無効"
              className="xl:ml-[32px] ml-[28px]"
              onChange={(e) =>
                setAddData({ ...addData, status: e.target.value })
              }
              checked={addData.status === "0" ? true : false}
            />
          </div>
        </FormGroupVerticalInput>
      </FormGroup>
    </div>
  );
};

export default MachineFormAdd;
